export default __webpack_public_path__ + "static/media/FECM.5fe8d245.png";